export enum ClinicalNoteScreens {
  EDITOR = 'EDITOR',
  PREVIEW = 'PREVIEW',
}
